import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between px-6 pt-5 pb-4 border-b border-black/[0.06]" }
const _hoisted_2 = { class: "text-[1.6rem] font-bold text-[#0f1f2e]" }
const _hoisted_3 = { class: "px-6 py-6 flex flex-col items-center gap-4 text-center" }
const _hoisted_4 = { class: "text-[1.45rem] text-[#3d5a6e] leading-relaxed" }
const _hoisted_5 = { class: "px-6 pb-6 flex flex-col gap-2" }

import { useLiveGroups } from "@/components/companionGroups/useLiveGroups";
import PopUp from "@/components/popup/PopUp.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'JoinSuccessPopup',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ["close", "share"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const { t } = useLiveGroups(
  { _skipInit: true },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  (_e: any, ..._args: any[]) => {},
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopUp, {
    "model-value": __props.isOpen,
    size: "sm",
    "onUpdate:modelValue": _cache[3] || (_cache[3] = v => !v && emit('close'))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(t)("joinedSessionTitle")), 1),
        _createElementVNode("button", {
          class: "w-8 h-8 rounded-full hover:bg-slate-100 flex items-center justify-center text-slate-400 transition",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.5",
            "stroke-linecap": "round"
          }, [
            _createElementVNode("line", {
              x1: "18",
              y1: "6",
              x2: "6",
              y2: "18"
            }),
            _createElementVNode("line", {
              x1: "6",
              y1: "6",
              x2: "18",
              y2: "18"
            })
          ], -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "w-14 h-14 rounded-full bg-green-50 flex items-center justify-center" }, [
          _createElementVNode("svg", {
            width: "26",
            height: "26",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "#22c55e",
            "stroke-width": "2.5",
            "stroke-linecap": "round"
          }, [
            _createElementVNode("path", { d: "M20 6L9 17l-5-5" })
          ])
        ], -1)),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)("joinedSessionBody")), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "w-full py-3 rounded-xl bg-[#4885d0] text-white text-[1.4rem] font-semibold hover:opacity-90 transition flex items-center justify-center gap-2",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('share')))
        }, [
          _cache[6] || (_cache[6] = _createElementVNode("svg", {
            width: "15",
            height: "15",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2.5",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, [
            _createElementVNode("circle", {
              cx: "18",
              cy: "5",
              r: "3"
            }),
            _createElementVNode("circle", {
              cx: "6",
              cy: "12",
              r: "3"
            }),
            _createElementVNode("circle", {
              cx: "18",
              cy: "19",
              r: "3"
            }),
            _createElementVNode("line", {
              x1: "8.59",
              y1: "13.51",
              x2: "15.42",
              y2: "17.49"
            }),
            _createElementVNode("line", {
              x1: "15.41",
              y1: "6.51",
              x2: "8.59",
              y2: "10.49"
            })
          ], -1)),
          _createTextVNode(" " + _toDisplayString(_unref(t)("shareSession")), 1)
        ]),
        _createElementVNode("button", {
          class: "w-full py-2.5 rounded-xl text-[1.35rem] text-[#7a9aaa] hover:text-[#0f1f2e] transition",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('close')))
        }, _toDisplayString(_unref(t)("close")), 1)
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})